module.exports = __webpack_public_path__ + "assets/slide-template-role.0026129c.svg";